import React, { Component } from 'react'
import { Button } from '@progress/kendo-react-buttons'
import PendingSuspendedDetalhes from './PendingSuspendedDetalhes'
import DadosEntidade from './DadosEntidade'
import History from './History'
import services from '../../../../services'
import moment from 'moment'

//CreateNewSeries -> create new series starting from 0 position of new row
//ReturnSeries -> returns series which have remaining seals in the rows
//CreateNewSealNumer -> creates series starting from the given position sent as parameters


class PendingSuspended extends Component {
    constructor(props){
        super(props)
        this.state = {
            tab : 'detalhes',
            entityDetail: {
                telephone: '',
                email: '',
                fax: ''
            },
            data:'',
            submitData:'',
            sealsRes:[],
            moreThan5milSeals:{},
            estatutosRes:[],
        }
    }
    componentDidMount = () => {
        this.getDetailsOnLoad()
        this.showTabDetails(this.state.tab)
    }

    componentDidUpdate(prevProps) {
        if(prevProps.date !== this.props.date){
            this.getDetailsOnLoad()
            this.updateTab("detalhes")
        }
    }

    updateTab = (tab) => {
        this.setState({
            tab
        }, () => {
            this.showTabDetails(this.state.tab)
        })
    }

    showTabDetails = (tab) => {
        let tabDetail = ''
        if(tab === 'detalhes') {
            tabDetail = (
                <PendingSuspendedDetalhes 
                    pedidos={this.props.pedidos} 
                    row={this.props.row}
                    setData={this.setData}
                    sealsRes={this.state.sealsRes}
                />
            )
        }
        else if(tab === 'dadosEntidade') {
            tabDetail = (
                <DadosEntidade 
                    row={this.props.row} 
                    entityDetail={this.state.entityDetail}
                    estatutosRes={this.state.estatutosRes}
                />
            )
        }
        else if(tab === 'history') {
            tabDetail = (
                <History 
                    pedidos={this.props.pedidos} 
                    row={this.props.row}
                />
            )
        }
        this.setState({
            tabDetail
        })
    }

    getDetailsOnLoad = async () => {
        // console.log("444333 row is ", this.props.row)

        let id = this.props.row && this.props.row.idRegistoSelo
        if(!id) return
        let link = "Sales/Sales_detailsAndHistory"
        let request = {
            id,
            type: this.props.row.estado
        }
        let res = await services.apiCall.requestApi(link, request, "post")
        console.log("112233 res ", res)

        if(res) {

            console.log("112233 res ", res)
            console.log("555666 res ", res)
        }
        
    }


    // estatutosApi= async ()=>{
    //     let Request = this.filterResponse();
    //     let link = "Sales/GetEstatutoListByEntityId"
    //     let estatutosRes = await services.apiCall.requestApi(link,Request);

    //     this.setState({
    //         estatutosRes,
    //     })
       
    // }

    filterResponse=()=>{
        let Request={
            "Filters": null,
            "SortBy": "",
            "IsSortTypeDESC": true,
            "IsPagination": true,
            "Page": 1,
            "PageSize": 10,
        }
        let {idEntidadeAplicacao} = this.props.row;
        Request["entityId"]=idEntidadeAplicacao;

        return Request;
    }

    
        //++++++++++++++++++++++++ red error invalid syntax near '-'
    moreThan5mil = () => {
        let link = "/Sales/CreateNewSeries"
        let req = {}
        req['Quantidade'] = +this.props.row['nSelos'].trim()
        req['EntidadeID'] = this.props.row['idEntidadeAplicacao']
        req['ObservacaoAprov'] = this.props.row['observacaoAprovacao']
        req['CodOperacao'] = this.props.row['codRegistoSelo']
        req['IDRegistoSelo'] = this.props.row['idRegistoSelo']
        console.log("the req body is ::::::" , req)
        services.apiCall.requestApi(link, req)
            .then(moreThan5milSeals => {
                //console.log("more than 5 million is.....", moreThan5milSeals)
                this.setState({
                    moreThan5milSeals
                })
                this.showTabDetails(this.state.tab)
                this.getEntityDetails(this.props.row['idEntidadeAplicacao'])
            })
            .catch(error => {
                this.setState({error})
            })

            //to be cleared beause of doubtful parameters in procedure call at the backend
    }
    
    getSeals = () => {
        let request = {}
        request.Quantidade = +this.props.row['nSelos'].trim()
        let link = "/Sales/ReturnSeries"
        services.apiCall.requestApi(link, request)
            .then(sealsRes => {
                console.log("the seals response is....", sealsRes)
                this.setState({
                    sealsRes
                })
                this.showTabDetails(this.state.tab)
                this.getEntityDetails(this.props.row['idEntidadeAplicacao'])
            })
            .catch(error => {
                this.setState({error})
            })
    }

    getEntityDetails = async (entity_id) => {
        try {
            let Request = {};
            Request.entityId = parseInt(entity_id);
            let link = "/Revenue/GetEntityDetail";
            let entityDetail={}
            let entityDetailResponse = await services.apiCall.requestApi(link, Request);
            //console.log("hello hi some thing");
            //console.log(res);
            if (entityDetailResponse) {
                console.log("the entity detaillllllll", entityDetailResponse)
                entityDetailResponse['v_CC_Entidade_Contact'].map(el => {
                    switch (el.codTipoContacto2) {
                        case "TLM":
                            entityDetail.telephone = el.contacto
                            break;
                        
                        case "EMAIL":
                            entityDetail.email = el.contacto
                            break;
                    
                        default:
                            break;
                    }
                    // if(el.codTipoContacto2 === "TLM"){
                    //     entityDetail.telephone = el.contacto
                    // }
                    // else if(el.codTipoContacto2 === "EMAIL") {
                    //     entityDetail.email = el.contacto
                    // }
                })
                
                this.setState({
                    entityDetail
                })
                console.log("usefullllll responseeeee ", this.state.entityDetail)
            }
        } catch (error) {
            this.setState({error})
        }
    }
    
    setData = (data) => {
        let newData = {...data}
        this.setState({
            data:{...this.state.data, ...newData}
        })
    }

    handleSubmit = () => {
        //call createNewSealNumber here
        this.createNewSealNumber()
        
    }
    afterCreateNewNumber = () => {
        let submitData = {...this.state.data}
        let date = moment(new Date()).format('YYYY-MM-DD')
        submitData['CodOperacaoSelo'] = this.props.row['codRegistoSelo'] || null
        submitData['IDRegistoSelo'] = this.props.row['idRegistoSelo'] || null
        submitData['Observacoes'] = this.state.data['Observacoes'] || null
        submitData['DataOperacao'] = date
        submitData['IDEntidadeAtribuida'] = this.props.row['idEntidadeAtribuida'] || this.props.row['IDEntidadeAplicacao'] || null
        submitData['QuantidadeSelos'] = +this.props.row['nSelos'].trim() || null
        //submitData['IDTipoSelo'] = this.props.row['tipoSelo']
        submitData['ResponsavelDestruicao'] = this.props.row['responsavelRececao'] || null
        submitData['NumeroSeloInicial'] = this.props.row['nInicial'] || null
        submitData['NumeroSeloFinal'] = this.props.row['nFinal'] || null
        submitData['IDEntidadeAplicacao'] = this.props.row['idEntidadeAplicacao'] || null

        Object.keys(submitData).map(key => {
            if(!submitData[key]){
                delete submitData[key]
            }
        })
        this.setState({
            submitData
        },() => {
            this.handlePendingRequests()
        })
    }

    createNewSealNumber = () => {
        let link = "/Sales/CreateNewSealNumber"
        let req = {}
        req["SeloAtual"] = this.state.data["NumeroSeloFinal"]
        req["Quantidade"] = +this.props.row["nSelos"].trim()
        req["IDEntidade"] = this.props.row['idEntidadeAplicacao']
        req["ObservacaoAprov"] = this.state.data["Observacoes"] ? this.state.data["Observacoes"] : '-'
        req["CodOperacao"] = this.props.row['codRegistoSelo']
        req["IDRegistoSelo"] = this.props.row['idRegistoSelo']
        req["SeloAtual"] = this.props.row['nFinal']

        services.apiCall.requestApi(link, req)
        .then(res => {
            console.log(res)
            this.afterCreateNewNumber()
        })
        .catch(error => {
            this.setState({error})
        })
    }

    handlePendingRequests = async () => {
        try {
            let dataReq = {...this.state.submitData}
            console.log("------------------++++++++++++++++++ ", dataReq )
            let link = "/Sales/HandlePendingRequests";
            let res = await services.apiCall.requestApi(link, dataReq);
            if(res) {
                console.log("the response we get ....", res)
            }
        } 
        catch(error) {
            this.setState({error})
        }
    }

    
    render() {
        return (
            <div className="modal-content">
                <div className="modal-header">
                    <span className="modal-title bold" style={{fontSize:"large"}}>
                        <b>Detalhe do pedido</b>
                    </span>
                    <div className="buttons">
                        <Button primary={true} className="remove btn-ivdp-primary cursor-pointer mr-2" onClick={() => this.handleSubmit()}>Gravar</Button>
                        <Button className="mr-2 k-primary btn-ivdp-secondary btn-theme remove ml-2 text-danger" data-dismiss="modal">Fechar</Button>
                    </div>
                    
                </div>
                <div className="modal-body">

                    {/** tab heading *****************************/}

                <div className="right-tab">
                    <ul className="nav nav-tabs d-flex text-center">
                        <li className="nav-item flex-fill">
                            <strong><a className={`nav-link selos-nav right-tab ${this.state.tab=='detalhes'?`active`:""}`}  onClick={() => this.updateTab('detalhes')} data-toggle="tab" href="#Detalhes">Detalhes</a></strong>
                        </li>
                        <li className="nav-item flex-fill">
                            <strong><a className={`nav-link selos-nav ${this.state.tab=='dadosEntidade'?`active`:""}`}  onClick={() => this.updateTab('dadosEntidade')} data-toggle="tab" href="#Dados entidade">Dados entidade</a></strong>
                        </li>
                        <li className="nav-item flex-fill">
                            <strong><a className={`nav-link selos-nav ${this.state.tab=='history'?`active`:""}`}  onClick={() => this.updateTab('history')} data-toggle="tab" href="#Histórico">Histórico</a></strong>
                        </li>
                    </ul>
                        
                        
                        {/* details as per tab**********************/}
                </div>
                    {this.state.tabDetail}
                </div>
            </div>
        )
    }
}

export default PendingSuspended